import React from "react";
import { isEmpty } from "lodash";
import {
  BoxShadowInput,
  EditPopover,
  Panel,
  RangeNumberInput,
  SelectInput,
  TabsV2,
  TextInput,
  UnitInput,
} from "../input";
import GrigoraCSSRenderer from "./../blocks/css-render";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRefresh } from "@fortawesome/free-solid-svg-icons";
import { changeTransition } from "../utils";
import { INPUT_LIMITS } from "../input-limits";

function Filter({ block, actions, ...props }) {
  const {
    id,
    props: { filters = {}, transition },
    dom,
  } = block;
  const { setProp } = actions;

  function InitialSettings() {
    return (
      <>
        <EditPopover
          label={"Filters"}
          canReset={!isEmpty(filters?.initial?.filter)}
          onReset={() => {
            var temp = { ...filters };
            setProp((props) => {
              props.filters = _.omit(temp, "initial.filter");
            });
          }}
          contentWidth={"250px"}
        >
          <UnitInput
            isResetVisible={false}
            value={filters?.initial?.filter?.blur}
            onChange={(val) => {
              setProp((props) => {
                props.filters = {
                  ...props.filters,
                  initial: {
                    ...props.filters?.initial,
                    filter: {
                      ...props.filters?.initial?.filter,
                      blur: val,
                    },
                  },
                };
              });
            }}
            units={[
              {
                value: "px",
                label: "px",
              },
              {
                value: "rem",
                label: "rem",
              },
            ]}
            label={"Blur"}
          />
          <RangeNumberInput
            value={filters?.initial?.filter?.opacity}
            onChange={(val) => {
              setProp((props) => {
                props.filters = {
                  ...props.filters,
                  initial: {
                    ...props.filters?.initial,
                    filter: {
                      ...props.filters?.initial?.filter,
                      opacity: val,
                    },
                  },
                };
              });
            }}
            min={0}
            max={100}
            step={1}
            label={"Opacity"}
          />
          <RangeNumberInput
            value={filters?.initial?.filter?.brightness}
            onChange={(val) => {
              setProp((props) => {
                props.filters = {
                  ...props.filters,
                  initial: {
                    ...props.filters?.initial,
                    filter: {
                      ...props.filters?.initial?.filter,
                      brightness: val,
                    },
                  },
                };
              });
            }}
            min={0}
            max={200}
            step={1}
            label={"Brightness"}
          />
          <RangeNumberInput
            value={filters?.initial?.filter?.contrast}
            onChange={(val) => {
              setProp((props) => {
                props.filters = {
                  ...props.filters,
                  initial: {
                    ...props.filters?.initial,
                    filter: {
                      ...props.filters?.initial?.filter,
                      contrast: val,
                    },
                  },
                };
              });
            }}
            min={0}
            max={200}
            step={1}
            label={"Contrast"}
          />

          <RangeNumberInput
            value={filters?.initial?.filter?.grayscale}
            onChange={(val) => {
              setProp((props) => {
                props.filters = {
                  ...props.filters,
                  initial: {
                    ...props.filters?.initial,
                    filter: {
                      ...props.filters?.initial?.filter,
                      grayscale: val,
                    },
                  },
                };
              });
            }}
            min={0}
            max={100}
            step={1}
            label={"Grayscale"}
          />

          <RangeNumberInput
            value={filters?.initial?.filter?.hue}
            onChange={(val) => {
              setProp((props) => {
                props.filters = {
                  ...props.filters,
                  initial: {
                    ...props.filters?.initial,
                    filter: {
                      ...props.filters?.initial?.filter,
                      hue: val,
                    },
                  },
                };
              });
            }}
            min={-360}
            max={360}
            step={1}
            label={"Hue"}
          />

          <RangeNumberInput
            value={filters?.initial?.filter?.invert}
            onChange={(val) => {
              setProp((props) => {
                props.filters = {
                  ...props.filters,
                  initial: {
                    ...props.filters?.initial,
                    filter: {
                      ...props.filters?.initial?.filter,
                      invert: val,
                    },
                  },
                };
              });
            }}
            min={0}
            max={100}
            step={1}
            label={"Invert"}
          />
          <RangeNumberInput
            value={filters?.initial?.filter?.saturation}
            onChange={(val) => {
              setProp((props) => {
                props.filters = {
                  ...props.filters,
                  initial: {
                    ...props.filters?.initial,
                    filter: {
                      ...props.filters?.initial?.filter,
                      saturation: val,
                    },
                  },
                };
              });
            }}
            min={0}
            max={200}
            step={1}
            label={"Saturation"}
          />
          <RangeNumberInput
            value={filters?.initial?.filter?.sepia}
            onChange={(val) => {
              setProp((props) => {
                props.filters = {
                  ...props.filters,
                  initial: {
                    ...props.filters?.initial,
                    filter: {
                      ...props.filters?.initial?.filter,
                      sepia: val,
                    },
                  },
                };
              });
            }}
            min={0}
            max={200}
            step={1}
            label={"Sepia"}
          />
          <BoxShadowInput
            hideSpread={true}
            maxShadows={1}
            isResetVisible={false}
            value={filters?.initial?.filter?.dropShadow}
            onChange={(val) => {
              setProp((props) => {
                props.filters = {
                  ...props.filters,
                  initial: {
                    ...props.filters?.initial,
                    filter: {
                      ...props.filters?.initial?.filter,
                      dropShadow: val,
                    },
                  },
                };
              });
            }}
            label={"Backdrop Shadow"}
          />
        </EditPopover>
        <EditPopover
          label={"Backdrop Filter"}
          canReset={!isEmpty(filters?.initial?.backDropFilter)}
          onReset={() => {
            var temp = { ...filters };
            setProp((props) => {
              props.filters = _.omit(temp, "initial.backDropFilter");
            });
          }}
          contentWidth={"250px"}
        >
          <UnitInput
            isResetVisible={false}
            value={filters?.initial?.backDropFilter?.blur}
            onChange={(val) => {
              setProp((props) => {
                props.filters = {
                  ...props.filters,
                  initial: {
                    ...props.filters?.initial,
                    backDropFilter: {
                      ...props.filters?.initial?.backdropFilter,
                      blur: val,
                    },
                  },
                };
              });
            }}
            units={[
              {
                value: "px",
                label: "px",
              },
              {
                value: "rem",
                label: "rem",
              },
            ]}
            label={"Blur"}
          />
          <RangeNumberInput
            value={filters?.initial?.backDropFilter?.opacity}
            onChange={(val) => {
              setProp((props) => {
                props.filters = {
                  ...props.filters,
                  initial: {
                    ...props.filters?.initial,
                    backDropFilter: {
                      ...props.filters?.initial?.backDropFilter,
                      opacity: val,
                    },
                  },
                };
              });
            }}
            min={0}
            max={100}
            step={1}
            label={"Opacity"}
          />
          <RangeNumberInput
            value={filters?.initial?.backDropFilter?.brightness}
            onChange={(val) => {
              setProp((props) => {
                props.filters = {
                  ...props.filters,
                  initial: {
                    ...props.filters?.initial,
                    backDropFilter: {
                      ...props.filters?.initial?.backDropFilter,
                      brightness: val,
                    },
                  },
                };
              });
            }}
            min={0}
            max={200}
            step={1}
            label={"Brightness"}
          />
          <RangeNumberInput
            value={filters?.initial?.backDropFilter?.contrast}
            onChange={(val) => {
              setProp((props) => {
                props.filters = {
                  ...props.filters,
                  initial: {
                    ...props.filters?.initial,
                    backDropFilter: {
                      ...props.filters?.initial?.backDropFilter,
                      contrast: val,
                    },
                  },
                };
              });
            }}
            min={0}
            max={200}
            step={1}
            label={"Contrast"}
          />

          <RangeNumberInput
            value={filters?.initial?.backDropFilter?.grayscale}
            onChange={(val) => {
              setProp((props) => {
                props.filters = {
                  ...props.filters,
                  initial: {
                    ...props.filters?.initial,
                    backDropFilter: {
                      ...props.filters?.initial?.backDropFilter,
                      grayscale: val,
                    },
                  },
                };
              });
            }}
            min={0}
            max={100}
            step={1}
            label={"Grayscale"}
          />

          <RangeNumberInput
            value={filters?.initial?.backDropFilter?.hue}
            onChange={(val) => {
              setProp((props) => {
                props.filters = {
                  ...props.filters,
                  initial: {
                    ...props.filters?.initial,
                    backDropFilter: {
                      ...props.filters?.initial?.backDropFilter,
                      hue: val,
                    },
                  },
                };
              });
            }}
            min={-360}
            max={360}
            step={1}
            label={"Hue"}
          />

          <RangeNumberInput
            value={filters?.initial?.backDropFilter?.invert}
            onChange={(val) => {
              setProp((props) => {
                props.filters = {
                  ...props.filters,
                  initial: {
                    ...props.filters?.initial,
                    backDropFilter: {
                      ...props.filters?.initial?.backDropFilter,
                      invert: val,
                    },
                  },
                };
              });
            }}
            min={0}
            max={100}
            step={1}
            label={"Invert"}
          />
          <RangeNumberInput
            value={filters?.initial?.backDropFilter?.saturation}
            onChange={(val) => {
              setProp((props) => {
                props.filters = {
                  ...props.filters,
                  initial: {
                    ...props.filters?.initial,
                    backDropFilter: {
                      ...props.filters?.initial?.backDropFilter,
                      saturation: val,
                    },
                  },
                };
              });
            }}
            min={0}
            max={200}
            step={1}
            label={"Saturation"}
          />
          <RangeNumberInput
            value={filters?.initial?.backDropFilter?.sepia}
            onChange={(val) => {
              setProp((props) => {
                props.filters = {
                  ...props.filters,
                  initial: {
                    ...props.filters?.initial,
                    backDropFilter: {
                      ...props.filters?.initial?.backDropFilter,
                      sepia: val,
                    },
                  },
                };
              });
            }}
            min={0}
            max={200}
            step={1}
            label={"Sepia"}
          />
          <BoxShadowInput
            hideSpread={true}
            maxShadows={1}
            isResetVisible={false}
            value={filters?.initial?.backDropFilter?.dropShadow}
            onChange={(val) => {
              setProp((props) => {
                props.filters = {
                  ...props.filters,
                  initial: {
                    ...props.filters?.initial,
                    backDropFilter: {
                      ...props.filters?.initial?.backDropFilter,
                      dropShadow: val,
                    },
                  },
                };
              });
            }}
            label={"Backdrop Shadow"}
          />
        </EditPopover>
        <SelectInput
          isResetVisible={false}
          value={filters?.initial?.blendMode}
          onChange={(val) => {
            setProp((props) => {
              props.filters = {
                ...props.filters,
                initial: {
                  ...props.filters?.initial,
                  blendMode: val,
                },
              };
            });
          }}
          options={[
            { label: "Normal", value: "normal" },
            { label: "Multiply", value: "multiply" },
            { label: "Screen", value: "screen" },
            { label: "Overlay", value: "overlay" },
            { label: "Darken", value: "darken" },
            { label: "Lighten", value: "lighten" },
            { label: "Color-dodge", value: "color-dodge" },
            { label: "Color-run", value: "color-run" },
            { label: "Hard-light", value: "hard-light" },
            { label: "Soft-light", value: "soft-light" },
            { label: "Difference", value: "difference" },
            { label: "Exclusion", value: "exclusion" },
            { label: "Hue", value: "hue" },
            { label: "Saturation", value: "saturation" },
            { label: "Color", value: "color" },
            { label: "Luminosity", value: "luminosity" },
          ]}
          label="Blend Mode"
        />
      </>
    );
  }

  function HoverSettings() {
    return (
      <>
        <EditPopover
          label={"Filters"}
          canReset={!isEmpty(filters?.hover?.filter)}
          onReset={() => {
            var temp = { ...filters };
            setProp((props) => {
              props.filters = _.omit(temp, "hover.filter");
            });
          }}
          contentWidth={"250px"}
        >
          <UnitInput
            isResetVisible={false}
            value={filters?.hover?.filter?.blur}
            onChange={(val) => {
              setProp((props) => {
                props.filters = {
                  ...props.filters,
                  hover: {
                    ...props.filters?.hover,
                    filter: {
                      ...props.filters?.hover?.filter,
                      blur: val,
                    },
                  },
                };
              });
            }}
            units={[
              {
                value: "px",
                label: "px",
              },
              {
                value: "rem",
                label: "rem",
              },
            ]}
            label={"Blur"}
          />
          <RangeNumberInput
            value={filters?.hover?.filter?.opacity}
            onChange={(val) => {
              setProp((props) => {
                props.filters = {
                  ...props.filters,
                  hover: {
                    ...props.filters?.hover,
                    filter: {
                      ...props.filters?.hover?.filter,
                      opacity: val,
                    },
                  },
                };
              });
            }}
            min={0}
            max={100}
            step={1}
            label={"Opacity"}
          />
          <RangeNumberInput
            value={filters?.hover?.filter?.brightness}
            onChange={(val) => {
              setProp((props) => {
                props.filters = {
                  ...props.filters,
                  hover: {
                    ...props.filters?.hover,
                    filter: {
                      ...props.filters?.hover?.filter,
                      brightness: val,
                    },
                  },
                };
              });
            }}
            min={0}
            max={200}
            step={1}
            label={"Brightness"}
          />
          <RangeNumberInput
            value={filters?.hover?.filter?.contrast}
            onChange={(val) => {
              setProp((props) => {
                props.filters = {
                  ...props.filters,
                  hover: {
                    ...props.filters?.hover,
                    filter: {
                      ...props.filters?.hover?.filter,
                      contrast: val,
                    },
                  },
                };
              });
            }}
            min={0}
            max={200}
            step={1}
            label={"Contrast"}
          />

          <RangeNumberInput
            value={filters?.hover?.filter?.grayscale}
            onChange={(val) => {
              setProp((props) => {
                props.filters = {
                  ...props.filters,
                  hover: {
                    ...props.filters?.hover,
                    filter: {
                      ...props.filters?.hover?.filter,
                      grayscale: val,
                    },
                  },
                };
              });
            }}
            min={0}
            max={100}
            step={1}
            label={"Grayscale"}
          />

          <RangeNumberInput
            value={filters?.hover?.filter?.hue}
            onChange={(val) => {
              setProp((props) => {
                props.filters = {
                  ...props.filters,
                  hover: {
                    ...props.filters?.hover,
                    filter: {
                      ...props.filters?.hover?.filter,
                      hue: val,
                    },
                  },
                };
              });
            }}
            min={-360}
            max={360}
            step={1}
            label={"Hue"}
          />

          <RangeNumberInput
            value={filters?.hover?.filter?.invert}
            onChange={(val) => {
              setProp((props) => {
                props.filters = {
                  ...props.filters,
                  hover: {
                    ...props.filters?.hover,
                    filter: {
                      ...props.filters?.hover?.filter,
                      invert: val,
                    },
                  },
                };
              });
            }}
            min={0}
            max={100}
            step={1}
            label={"Invert"}
          />
          <RangeNumberInput
            value={filters?.hover?.filter?.saturation}
            onChange={(val) => {
              setProp((props) => {
                props.filters = {
                  ...props.filters,
                  hover: {
                    ...props.filters?.hover,
                    filter: {
                      ...props.filters?.hover?.filter,
                      saturation: val,
                    },
                  },
                };
              });
            }}
            min={0}
            max={200}
            step={1}
            label={"Saturation"}
          />
          <RangeNumberInput
            value={filters?.hover?.filter?.sepia}
            onChange={(val) => {
              setProp((props) => {
                props.filters = {
                  ...props.filters,
                  hover: {
                    ...props.filters?.hover,
                    filter: {
                      ...props.filters?.hover?.filter,
                      sepia: val,
                    },
                  },
                };
              });
            }}
            min={0}
            max={200}
            step={1}
            label={"Sepia"}
          />
          <BoxShadowInput
            hideSpread={true}
            maxShadows={1}
            isResetVisible={false}
            value={filters?.hover?.filter?.dropShadow}
            onChange={(val) => {
              setProp((props) => {
                props.filters = {
                  ...props.filters,
                  hover: {
                    ...props.filters?.hover,
                    filter: {
                      ...props.filters?.hover?.filter,
                      dropShadow: val,
                    },
                  },
                };
              });
            }}
            label={"Backdrop Shadow"}
          />
        </EditPopover>
        <EditPopover
          label={"Backdrop Filter"}
          canReset={!isEmpty(filters?.hover?.backDropFilter)}
          onReset={() => {
            var temp = { ...filters };
            setProp((props) => {
              props.filters = _.omit(temp, "hover.backDropFilter");
            });
          }}
          contentWidth={"250px"}
        >
          <UnitInput
            isResetVisible={false}
            value={filters?.hover?.backDropFilter?.blur}
            onChange={(val) => {
              setProp((props) => {
                props.filters = {
                  ...props.filters,
                  hover: {
                    ...props.filters?.hover,
                    backDropFilter: {
                      ...props.filters?.hover?.backDropFilter,
                      blur: val,
                    },
                  },
                };
              });
            }}
            units={[
              {
                value: "px",
                label: "px",
              },
              {
                value: "rem",
                label: "rem",
              },
            ]}
            label={"Blur"}
          />
          <RangeNumberInput
            value={filters?.hover?.backDropFilter?.opacity}
            onChange={(val) => {
              setProp((props) => {
                props.filters = {
                  ...props.filters,
                  hover: {
                    ...props.filters?.hover,
                    backDropFilter: {
                      ...props.filters?.hover?.backDropFilter,
                      opacity: val,
                    },
                  },
                };
              });
            }}
            min={0}
            max={100}
            step={1}
            label={"Opacity"}
          />
          <RangeNumberInput
            value={filters?.hover?.backDropFilter?.brightness}
            onChange={(val) => {
              setProp((props) => {
                props.filters = {
                  ...props.filters,
                  hover: {
                    ...props.filters?.hover,
                    backDropFilter: {
                      ...props.filters?.hover?.backDropFilter,
                      brightness: val,
                    },
                  },
                };
              });
            }}
            min={0}
            max={200}
            step={1}
            label={"Brightness"}
          />
          <RangeNumberInput
            value={filters?.hover?.backDropFilter?.contrast}
            onChange={(val) => {
              setProp((props) => {
                props.filters = {
                  ...props.filters,
                  hover: {
                    ...props.filters?.hover,
                    backDropFilter: {
                      ...props.filters?.hover?.backDropFilter,
                      contrast: val,
                    },
                  },
                };
              });
            }}
            min={0}
            max={200}
            step={1}
            label={"Contrast"}
          />

          <RangeNumberInput
            value={filters?.hover?.backDropFilter?.grayscale}
            onChange={(val) => {
              setProp((props) => {
                props.filters = {
                  ...props.filters,
                  hover: {
                    ...props.filters?.hover,
                    backDropFilter: {
                      ...props.filters?.hover?.backDropFilter,
                      grayscale: val,
                    },
                  },
                };
              });
            }}
            min={0}
            max={100}
            step={1}
            label={"Grayscale"}
          />

          <RangeNumberInput
            value={filters?.hover?.backDropFilter?.hue}
            onChange={(val) => {
              setProp((props) => {
                props.filters = {
                  ...props.filters,
                  hover: {
                    ...props.filters?.hover,
                    backDropFilter: {
                      ...props.filters?.hover?.backDropFilter,
                      hue: val,
                    },
                  },
                };
              });
            }}
            min={-360}
            max={360}
            step={1}
            label={"Hue"}
          />

          <RangeNumberInput
            value={filters?.hover?.backDropFilter?.invert}
            onChange={(val) => {
              setProp((props) => {
                props.filters = {
                  ...props.filters,
                  hover: {
                    ...props.filters?.hover,
                    backDropFilter: {
                      ...props.filters?.hover?.backDropFilter,
                      invert: val,
                    },
                  },
                };
              });
            }}
            min={0}
            max={100}
            step={1}
            label={"Invert"}
          />
          <RangeNumberInput
            value={filters?.hover?.backDropFilter?.saturation}
            onChange={(val) => {
              setProp((props) => {
                props.filters = {
                  ...props.filters,
                  hover: {
                    ...props.filters?.hover,
                    backDropFilter: {
                      ...props.filters?.hover?.backDropFilter,
                      saturation: val,
                    },
                  },
                };
              });
            }}
            min={0}
            max={200}
            step={1}
            label={"Saturation"}
          />
          <RangeNumberInput
            value={filters?.hover?.backDropFilter?.sepia}
            onChange={(val) => {
              setProp((props) => {
                props.filters = {
                  ...props.filters,
                  hover: {
                    ...props.filters?.hover,
                    backDropFilter: {
                      ...props.filters?.hover?.backDropFilter,
                      sepia: val,
                    },
                  },
                };
              });
            }}
            min={0}
            max={200}
            step={1}
            label={"Sepia"}
          />
          <BoxShadowInput
            hideSpread={true}
            maxShadows={1}
            isResetVisible={false}
            value={filters?.hover?.backDropFilter?.dropShadow}
            onChange={(val) => {
              setProp((props) => {
                props.filters = {
                  ...props.filters,
                  hover: {
                    ...props.filters?.hover,
                    backDropFilter: {
                      ...props.filters?.hover?.backDropFilter,
                      dropShadow: val,
                    },
                  },
                };
              });
            }}
            label={"Backdrop Shadow"}
          />
        </EditPopover>
        <SelectInput
          isResetVisible={false}
          value={filters?.hover?.blendMode}
          onChange={(val) => {
            setProp((props) => {
              props.filters = {
                ...props.filters,
                hover: {
                  ...props.filters?.hover,
                  blendMode: val,
                },
              };
            });
          }}
          options={[
            { label: "Normal", value: "normal" },
            { label: "Multiply", value: "multiply" },
            { label: "Screen", value: "screen" },
            { label: "Overlay", value: "overlay" },
            { label: "Darken", value: "darken" },
            { label: "Lighten", value: "lighten" },
            { label: "Color-dodge", value: "color-dodge" },
            { label: "Color-run", value: "color-run" },
            { label: "Hard-light", value: "hard-light" },
            { label: "Soft-light", value: "soft-light" },
            { label: "Difference", value: "difference" },
            { label: "Exclusion", value: "exclusion" },
            { label: "Hue", value: "hue" },
            { label: "Saturation", value: "saturation" },
            { label: "Color", value: "color" },
            { label: "Luminosity", value: "luminosity" },
          ]}
          label="Blend Mode"
        />
        <TextInput
          minLength={INPUT_LIMITS["custom-classname"].minlength}
          maxLength={INPUT_LIMITS["custom-classname"].maxlength}
          isResetVisible={false}
          value={filters?.hover?.parent}
          onChange={(val) => {
            setProp((props) => {
              props.filters = {
                ...props.filters,
                hover: {
                  ...props.filters?.hover,
                  parent: val,
                },
              };
            });
          }}
          placeholder=".class-name"
          label={"Custom Parent Hover Trigger"}
        />
        <RangeNumberInput
          min={0}
          max={10}
          step={0.01}
          value={transition?.types?.["filter"]?.duration}
          onChange={(val) => {
            changeTransition(
              ["filter", "backdrop-filter", "mix-blend-mode"],
              { duration: val },
              transition,
              setProp,
            );
          }}
          label={"Duration"}
        />
        <RangeNumberInput
          min={0}
          max={10}
          step={0.01}
          value={transition?.types?.["filter"]?.delay}
          onChange={(val) => {
            changeTransition(
              ["filter", "backdrop-filter", "mix-blend-mode"],
              { delay: val },
              transition,
              setProp,
            );
          }}
          label={"Delay"}
        />
        <SelectInput
          isResetVisible={false}
          value={transition?.types?.["filter"]?.easing}
          onChange={(val) => {
            changeTransition(
              ["filter", "backdrop-filter", "mix-blend-mode"],
              { easing: val },
              transition,
              setProp,
            );
          }}
          options={[
            { label: "Linear", value: "" },
            { label: "Ease", value: "ease" },
            { label: "Ease In", value: "ease-in" },
            { label: "Ease Out", value: "ease-out" },
            { label: "Ease In Out", value: "ease-in-out" },
          ]}
          label="Easing"
        />
      </>
    );
  }

  const tabs = [
    {
      label: "Initial",
      key: "initial",
      children: InitialSettings(),
    },
    {
      label: "Hover",
      key: "hover",
      children: HoverSettings(),
    },
  ];

  return (
    <>
      <Panel title={"Filter"} initialOpen={false}>
        {!(filters && isEmpty(filters)) && (
          <>
            <div className="flex text-xs justify-between mb-2 px-1">
              Reset Filter
              <div
                onClick={() => {
                  setProp((props) => {
                    props.filters = undefined;
                  });
                }}
                className="ml-2 cursor-pointer"
              >
                <FontAwesomeIcon icon={faRefresh} size="sm" />
              </div>
            </div>
          </>
        )}
        <TabsV2 items={tabs} />
      </Panel>
    </>
  );
}

function transformProps(props, supportProps) {
  const { id, filters } = props;
  if (
    (!isEmpty(filters) && filters?.initial?.filter?.blur) ||
    filters?.initial?.filter?.opacity ||
    filters?.initial?.filter?.contrast ||
    filters?.initial?.filter?.brightness ||
    filters?.initial?.filter?.dropShadow ||
    filters?.initial?.filter?.hue ||
    filters?.initial?.filter?.invert ||
    filters?.initial?.filter?.saturation ||
    filters?.initial?.filter?.sepia ||
    filters?.initial?.filter?.grayscale ||
    filters?.hover?.filter?.blur ||
    filters?.hover?.filter?.opacity ||
    filters?.hover?.filter?.contrast ||
    filters?.hover?.filter?.brightness ||
    filters?.hover?.filter?.dropShadow ||
    filters?.hover?.filter?.hue ||
    filters?.hover?.filter?.invert ||
    filters?.hover?.filter?.saturation ||
    filters?.hover?.filter?.sepia ||
    filters?.hover?.filter?.grayscale ||
    filters?.initial?.backDropFilter?.blur ||
    filters?.initial?.backDropFilter?.opacity ||
    filters?.initial?.backDropFilter?.contrast ||
    filters?.initial?.backDropFilter?.brightness ||
    filters?.initial?.backDropFilter?.dropShadow ||
    filters?.initial?.backDropFilter?.hue ||
    filters?.initial?.backDropFilter?.invert ||
    filters?.initial?.backDropFilter?.saturation ||
    filters?.initial?.backDropFilter?.sepia ||
    filters?.initial?.backDropFilter?.grayscale ||
    filters?.hover?.backDrDpFilter?.blur ||
    filters?.hover?.backDropFilter?.opacity ||
    filters?.hover?.backDrDpFilter?.contrast ||
    filters?.hover?.backDrDpFilter?.brightness ||
    filters?.hover?.backDrDpFilter?.dropShadow ||
    filters?.hover?.backDrDpFilter?.hue ||
    filters?.hover?.backDropFilter?.invert ||
    filters?.hover?.backDropFilter?.saturation ||
    filters?.hover?.backDropFilter?.sepia ||
    filters?.hover?.backDropFilter?.grayscale ||
    filters?.hover?.parent ||
    filters?.initial?.blendMode ||
    filters?.hover?.blendMode
  ) {
    supportProps = {
      ...supportProps,
      className: {
        ...(supportProps.className ? supportProps.className : {}),
        [`filter-${id}`]: true,
      },
    };
  }
  return supportProps;
}

function dynamicCSS(id, props) {
  const { filters } = props;
  if (
    (!isEmpty(filters) && filters?.initial?.filter?.blur) ||
    filters?.initial?.filter?.opacity ||
    filters?.initial?.filter?.contrast ||
    filters?.initial?.filter?.brightness ||
    filters?.initial?.filter?.dropShadow ||
    filters?.initial?.filter?.hue ||
    filters?.initial?.filter?.invert ||
    filters?.initial?.filter?.saturation ||
    filters?.initial?.filter?.sepia ||
    filters?.initial?.filter?.grayscale ||
    filters?.hover?.filter?.blur ||
    filters?.hover?.filter?.opacity ||
    filters?.hover?.filter?.contrast ||
    filters?.hover?.filter?.brightness ||
    filters?.hover?.filter?.dropShadow ||
    filters?.hover?.filter?.hue ||
    filters?.hover?.filter?.invert ||
    filters?.hover?.filter?.saturation ||
    filters?.hover?.filter?.sepia ||
    filters?.hover?.filter?.grayscale ||
    filters?.initial?.backDropFilter?.blur ||
    filters?.initial?.backDropFilter?.opacity ||
    filters?.initial?.backDropFilter?.contrast ||
    filters?.initial?.backDropFilter?.brightness ||
    filters?.initial?.backDropFilter?.dropShadow ||
    filters?.initial?.backDropFilter?.hue ||
    filters?.initial?.backDropFilter?.invert ||
    filters?.initial?.backDropFilter?.saturation ||
    filters?.initial?.backDropFilter?.sepia ||
    filters?.initial?.backDropFilter?.grayscale ||
    filters?.hover?.backDrDpFilter?.blur ||
    filters?.hover?.backDropFilter?.opacity ||
    filters?.hover?.backDrDpFilter?.contrast ||
    filters?.hover?.backDrDpFilter?.brightness ||
    filters?.hover?.backDrDpFilter?.dropShadow ||
    filters?.hover?.backDrDpFilter?.hue ||
    filters?.hover?.backDropFilter?.invert ||
    filters?.hover?.backDropFilter?.saturation ||
    filters?.hover?.backDropFilter?.sepia ||
    filters?.hover?.backDropFilter?.grayscale ||
    filters?.hover?.parent ||
    filters?.initial?.blendMode ||
    filters?.hover?.blendMode
  ) {
    return `
            .filter-${id}{
                ${GrigoraCSSRenderer.filter(filters?.initial?.filter)}
                ${GrigoraCSSRenderer.backgroundMixBlendMode(
                  filters?.initial?.blendMode,
                )}
                ${GrigoraCSSRenderer.backdropFilter(
                  filters?.initial?.backDropFilter,
                )}
            }

            ${
              filters?.hover?.parent && parent !== ""
                ? `${filters?.hover?.parent}:hover .filter-${id}`
                : `.filter-${id}:hover`
            }{
        ${GrigoraCSSRenderer.filter(filters?.hover?.filter)}
        ${GrigoraCSSRenderer.backgroundMixBlendMode(filters?.hover?.blendMode)}
        ${GrigoraCSSRenderer.backdropFilter(filters?.hover?.backDropFilter)}
              }
        `;
  }
  return "";
}

const supportSchema = {
  id: "grigora/filter",
  name: "Filter",
  component: Filter,
  transformProps: transformProps,
  dynamicCSS: dynamicCSS,
};

export default supportSchema;
